export default "__VITE_ASSET__DNPf42Fl__"